import { apiGetFleetDriver, apiGetFleetManager, apiGetTicketingApproval, apiGetApprovalsDetails, apiSearchbyALL, apiTicketListData, apiGetDealerSugessionsData, ApigetSpocSugessionData, ApigetExecutiveSugessionData, apiGetTechnicianData, apiGetTechinciansugession, apiGetUserPlantCode, apiGetShiftRoasterData, apiSearchForSuggestion, apiGetNewFleetManagerDetails, apiSearchbyAgent, apiGetAllRSAVehicleData, apiDeleteuploadFile, apigetSelectedDealersDetails, apiGetCustomerTicketListData } from "services/ViewTicketService";
import appConfig from 'configs/app.config'
import axios from "axios";
import Clock from "assets/icons/clock";
import Flag from "assets/icons/flag";
import ThumbDown from "assets/icons/thumbDown";
import Cancel from "assets/icons/cancel";
import CancelBin from "assets/icons/cancelBin";
import { HiOutlineHandThumbUp } from "react-icons/hi2";
import Reopen from "assets/icons/reopen";
import ForwardedTo from "assets/icons/forwardedTo";
import Pause from "assets/icons/pause";
import { OpenNotification } from "views/Servicefile";
const { apiPrefix } = appConfig

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// export const getTicketsData = createAsyncThunk(
//     'dashboards/data/getTicketsData',
//     async (data) => {
//         const response = await apiTicketDashboardData(data)
//         return response
//     }
// )


export const getSearchbyAll = createAsyncThunk(
    "viewTickets/data/getSearchbyAll",
    async (data) => {

        try {
            const response = await apiSearchbyALL(data)
            return response.data
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getSpocSugessionData = createAsyncThunk(
    "viewTickets/data/getSpocSugessionData",
    async (data) => {

        try {
            const response = await ApigetSpocSugessionData(data)
            return response.data
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getExecutiveSugessionData = createAsyncThunk(
    "viewTickets/data/getExecutiveSugessionData",
    async (data) => {

        try {
            const response = await ApigetExecutiveSugessionData(data)
            return response.data
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getTicketList = createAsyncThunk(
    'viewTickets/data/getTicketList',
    async (data) => {

        try {
            const response = await apiTicketListData(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getTicketingApprovalData = createAsyncThunk(
    'viewTickets/data/getTicketingApprovalData',
    async (data) => {

        try {
            const response = await apiGetTicketingApproval(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getKMValue = (number) => {
    //console.log(number);
    if (number) {
        const integerLength = Math.floor(number).toString().length;
        if (integerLength > 6) {
            let numberValue = (number / 1000).toFixed();
            return numberValue;
        } else {
            return Math.floor(number)
        }
    }
};




export const getApprovalTicketingData = createAsyncThunk(
    'viewTickets/data/getApprovalTicketingData',
    async (data) => {

        try {
            const response = await apiGetApprovalsDetails(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getFleetManagerData = createAsyncThunk(
    'viewTickets/data/getFleetManagerData',
    async (data) => {

        try {
            const response = await apiGetFleetManager(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)

export const formatDuration = (seconds) => {
    const secondsInYear = 365.25 * 24 * 60 * 60; // ~31,557,600
    const secondsInMonth = secondsInYear / 12;   // ~2,629,800
    const secondsInDay = 24 * 3600;
    const secondsInHour = 3600;
    const secondsInMinute = 60;

    let years = Math.floor(seconds / secondsInYear);
    seconds %= secondsInYear;

    let months = Math.floor(seconds / secondsInMonth);
    seconds %= secondsInMonth;

    let days = Math.floor(seconds / secondsInDay);
    seconds %= secondsInDay;

    let hours = Math.floor(seconds / secondsInHour);
    seconds %= secondsInHour;

    let minutes = Math.floor(seconds / secondsInMinute);
    let secs = Math.floor(seconds % secondsInMinute);

    if (years > 0) {
        return `${years > 1 ? `${years} years ` : `${years} year `}${months > 1 ? `${months} months ` : `${months} month `}`;
    } else if (months > 0) {
        return `${months > 1 ? `${months} months ` : `${months} month `}${days > 1 ? `${days} days ` : `${days} day `}`;
    } else if (days > 0) {
        return `${days > 1 ? `${days} days ` : `${days} day `}${hours > 1 ? `${hours} hours ` : `${hours} hour `}`;
    } else if (hours > 0) {
        return `${hours > 1 ? `${hours} hours ` : `${hours} hour `}${minutes > 1 ? `${minutes} minutes ` : `${minutes} minute `}`;
    } else if (minutes > 0) {
        return `${minutes > 1 ? `${minutes} minutes ` : `${minutes} minute `}${secs > 1 ? `${secs} secs ` : `${secs} sec `}`;
    }

    return '';
    //return `${years > 0 ? `${years}y ` : ""}${months > 0 ? `${months}mo ` : ""}${days > 0 ? `${days}d ` : ""}${hours > 0 ? `${hours}h ` : ""}${minutes > 0 ? `${minutes}m ` : ""}${secs}s`;
};

//  DEALER_SPOC: "DEALER_SPOC",
//     UPTIME_CENTRE_ANALYST: "UPTIME_CENTRE_ANALYST",
//     DEALER_SPOC_MANAGER: "DEALER_SPOC_MANAGER",
//     UPTIME_CENTRE_EXECUTIVE: "UPTIME_CENTRE_EXECUTIVE",
//     DEALER_GENERAL_MANAGER:"DEALER_GENERAL_MANAGER",
//     BUSINESS_ADMIN:"BUSINESS_ADMIN",

export const getStatusListValues = (userType, Status) => {
    let statusList;
    if (userType == "HQ" || userType == "UPTIME_CENTRE_ANALYST" || userType == "BUSINESS_ADMIN") {
        switch (Status) {
            case 'New':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList
            case 'Inprogress':
                statusList = [
                    { label: 'Hold', icon: <Pause />, c: '#ca8a04', bg: '#fefce8' },
                    { label: 'Forward to dealer', icon: <ForwardedTo />, c: '#EA580C', bg: '#FFF7ED' },
                    { label: 'Resolved', icon: <Flag />, c: '#16A34A', bg: '#f0fdf4', disabled: false },
                    { label: 'Customer refused', icon: <ThumbDown />, c: '#ca8a04', bg: '#fefce8', disabled: false },
                    { label: 'No trouble found', icon: <Cancel />, c: '#16A34A', bg: '#f0fdf4', disabled: false },
                    { label: 'Request to cancel', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'Hold':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList
            case 'Resolved':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                    { label: 'Closed', icon: <Flag className="mr-2" />, c: '#ca8a04', bg: '#fefce8', disabled: false },

                ]
                return statusList
            case 'Closed':
                statusList = []
                return statusList
            case 'Customer refused':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'No trouble found':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'Reopen':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList

            default:
                statusList = []
                return statusList
        }
    } else if (userType == "UPTIME_CENTRE_EXECUTIVE") {
        switch (Status) {
            case 'New':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList
            case 'Inprogress':
                statusList = [
                    { label: 'Hold', icon: <Pause />, c: '#ca8a04', bg: '#fefce8' },
                    { label: 'Forward to dealer', icon: <ForwardedTo />, c: '#EA580C', bg: '#FFF7ED' },
                    { label: 'Resolved', icon: <Flag />, c: '#16A34A', bg: '#f0fdf4', disabled: false },
                    { label: 'Customer refused', icon: <ThumbDown />, c: '#ca8a04', bg: '#fefce8', disabled: false },
                    { label: 'No trouble found', icon: <Cancel />, c: '#16A34A', bg: '#f0fdf4', disabled: false },
                    { label: 'Request to cancel', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'Hold':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList
            case 'Resolved':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                    { label: 'Closed', icon: <Flag className="mr-2" />, c: '#ca8a04', bg: '#fefce8', disabled: false },

                ]
                return statusList
            case 'Closed':
                statusList = []
                return statusList
            case 'Customer refused':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'No trouble found':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'Reopen':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList
            default:
                statusList = []
                return statusList
        }
    } else if (userType == "DEALER_SPOC") {
        switch (Status) {
            case 'New':
                statusList = [
                    { label: 'Acknowledged', icon: <HiOutlineHandThumbUp size={22} />, c: '#4B5563', bg: '#E5E7EB', disabled: false },
                ]
                return statusList
            case 'Acknowledged':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList
            case 'Inprogress':
                statusList = [
                    { label: 'Hold', icon: <Pause />, c: '#ca8a04', bg: '#fefce8' },
                    { label: 'Resolved', icon: <Flag />, c: '#16A34A', bg: '#f0fdf4', disabled: false },
                    { label: 'Customer refused', icon: <ThumbDown />, c: '#ca8a04', bg: '#fefce8', disabled: false },
                    { label: 'No trouble found', icon: <Cancel />, c: '#16A34A', bg: '#f0fdf4', disabled: false },
                ]
                return statusList
            case 'Hold':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList
            case 'Resolved':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'Customer refused':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList
            case 'No trouble found':
                statusList = [
                    { label: 'Request to reopen', icon: <CancelBin />, c: '#dc2626', bg: '#fefce8' },
                ]
                return statusList

            case 'Reopen':
                statusList = [
                    { label: 'Inprogress', icon: <Clock />, c: '#2563eb', bg: '#eff6ff', disabled: false },
                ]
                return statusList

            default:
                statusList = []
                return statusList
        }
    } else {
        return []
    }
}
export const getDateValue = (date, flag) => {
    if (date) {
        const dateObj = new Date(date);
        console.log(dateObj);
        // Format date as DD:MMM:YYYY
        const day = dateObj.getDate().toString().padStart(2, '0');
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const month = monthNames[dateObj.getMonth()];
        const year = dateObj.getFullYear();

        const formattedDate = `${day} ${month} ${year}`;

        // Get hours and minutes
        let hours = dateObj.getHours();
        console.log(hours)
        const minutes = dateObj.getMinutes();
        console.log(minutes)
        // Determine AM/PM and convert to 12-hour format
        const period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM

        // Return formatted value
        if (flag) {
            return (
                <span title={date}>
                    {formattedDate}
                </span>
            );
        } else {
            return (
                <span title={date}>
                    {formattedDate}, {hours < 10 ? "0" + hours : hours}:{minutes < 10 ? "0" + minutes : minutes} {period}
                </span>
            );
        }

    } else {
        return "";
    }
};
export const fetchCustomerDetails = async (contact, customerName, phone_number_type, ticketId) => {
    try {
        // const response = await axios.get(`${apiPrefix}/operation/vehicle-masters/customer-details?mobile_no=${contact}&phone_number_type=${phone_number_type ? phone_number_type : 0}`, {
        //     headers: {
        //         Authorization: `Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJBaXJsaW5xLCBMTEMiLCJhdWQiOiJUZCBBY2NvdW50cyBBcHBsaWNhdGlvbiIsImlhdCI6MTczNjIyMjI0Niwic3ViIjoidmlvbiIsInVzZXJJZCI6InZpb24xIiwiYXV0aG9yaXRpZXMiOltdLCJleHAiOjQ4OTE4OTU4NDV9.N5jLLwtJ_bj7dopWUTrhl8bCF6YvwndaSOvy0kVZpQdndUSQilt2Yer4f8DyPU6Ctvf7J7EQqPjB3mEhAHBK7A`,
        //         'Content-Type': 'application/json',
        //         'User': 'vion1'
        //     }
        // });
        const response = await apiGetCustomerTicketListData({
            mobile_no: contact,
            phone_number_type: phone_number_type ? phone_number_type : 0
        })
        const mobile_code = response?.data?.response?.mobile_code
        try {
            const iframewidget = document.getElementById('dialer-widget');
            if (iframewidget && iframewidget.contentWindow) {
                iframewidget.contentWindow.postMessage(`TICKETINFO|${ticketId}`, "*");
            }
            window.dialSipCall(contact, mobile_code, customerName);
        } catch (err) {
            console.error("Error dialing SIP call:", err);
        }

    } catch (error) {
        console.error("API error:", error);
        throw error;
    }
};
export const getDateOnly = (date) => {
    if (date) {
        const dateObj = new Date(date);
        // Format date as DD:MMM:YYYY
        const day = dateObj.getDate().toString().padStart(2, '0');
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const month = monthNames[dateObj.getMonth()];
        const year = dateObj.getFullYear();

        const formattedDate = `${day} ${month} ${year}`;
        // Return formatted value
        return (<span title={date}>
            {formattedDate}
        </span>)

    } else {
        return "";
    }
};

export const getDateOnlyForActivityLog = (date) => {
    if (date) {
        console.log(date)
        const parts = date.split("-");
        const formattedInput = parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : date;

        const dateObj = new Date(formattedInput);
        const newDate = new Date();
        console.log(dateObj)
        // Format date as DD:MMM:YYYY
        const day = dateObj.getDate().toString().padStart(2, '0');
        const today = newDate.getDate().toString().padStart(2, '0');
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const month = monthNames[dateObj.getMonth()];
        const year = dateObj.getFullYear();
        const thismonth = monthNames[newDate.getMonth()];
        const thisyear = newDate.getFullYear();

        const toDate = `${today} ${thismonth} ${thisyear}`;

        const formattedDate = `${day} ${month} ${year}`;
        console.log(formattedDate)
        // Return formatted value
        if (toDate == formattedDate) {
            // return "Today" formattedDate
            return (<span title={date}>
                {"Today, " + formattedDate}
            </span>)
        } else {
            return (<span title={date}>
                {formattedDate}
            </span>)
        }


    } else {
        return "";
    }
};

export const getDateformateOnly = (date) => {
    if (date) {
        const dateObj = new Date(date);
        // Format date as DD:MMM:YYYY
        const day = dateObj.getDate().toString().padStart(2, '0');
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        // const monthNames = [
        //     "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        //     "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        // ];
        // const month = monthNames[dateObj.getMonth()];
        const year = dateObj.getFullYear();

        const formattedDate = `${year}-${month}-${day}`;
        // Return formatted value
        return formattedDate;

    } else {
        return "";
    }
};

export const getUTCDateValue = (date) => {
    console.log(date)
    if (date) {
        var datevalue = new Date(date);
        // var now_utc = Date.UTC(datevalue.getUTCFullYear(), datevalue.getUTCMonth(),
        // datevalue.getUTCDate(), datevalue.getUTCHours(),
        // datevalue.getUTCMinutes(), datevalue.getUTCSeconds());
        console.log(datevalue.toISOString());
        return datevalue.toISOString();
    } else {
        return "";
    }
};

export const getFleetDriverData = createAsyncThunk(
    'viewTickets/data/getFleetDriverData',
    async (data) => {

        try {
            const response = await apiGetFleetDriver(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)

export const getNewFleetManagerDetails = createAsyncThunk(
    'trackandTrace/data/getNewFleetManagerDetails',
    async (data) => {

        try {
            const response = await apiGetNewFleetManagerDetails(data)
            return response.data
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)

export const getDealerDataSugessions = createAsyncThunk(
    'viewTickets/data/getDealerDataSugessions',
    async (data) => {

        try {
            const response = await apiGetDealerSugessionsData(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getTechnicianData = createAsyncThunk(
    'viewTickets/data/getTechnicianData',
    async (data) => {

        try {
            const response = await apiGetTechnicianData(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getTechinciansugession = createAsyncThunk(
    'viewTickets/data/getTechinciansugession',
    async (data) => {

        try {
            const response = await apiGetTechinciansugession(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getUserPlantCode = createAsyncThunk(
    'viewTickets/data/getUserPlantCode',
    async (data) => {

        try {
            const response = await apiGetUserPlantCode(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getShiftRoasterData = createAsyncThunk(
    'viewTickets/data/getShiftRoasterData',
    async (data) => {

        try {
            const response = await apiGetShiftRoasterData(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getAllRSAVehicleData = createAsyncThunk(
    'viewTickets/data/getAllRSAVehicleData',
    async (data) => {

        try {
            const response = await apiGetAllRSAVehicleData(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getSelectedVehicleData = createAsyncThunk(
    'trackandTrace/data/getSelectedVehicleData',
    async (data) => {

        try {
            const response = await apigetSelectedDealersDetails(data)
            return response.data
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)
export const getSearchForSuggestion = createAsyncThunk(
    'viewTickets/data/getSearchForSuggestion',
    async (data) => {

        try {
            const response = await apiSearchForSuggestion(data)
            return response
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)



export const getSearchbyAgent = createAsyncThunk(
    "dtcdashBoardList/data/getSearchbyAgent",
    async (data) => {

        try {
            const response = await apiSearchbyAgent(data)
            return response.data
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)


// export const getTicketListCount = createAsyncThunk(
//     'viewTickets/data/getTicketListCount',
//     async (data) => {
//         const response = await apiTicketListCount(data)
//         return response
//     }
// )
export const apiDeleteUploadFile = createAsyncThunk(
    "regionParameter/data/apiUpdateRegionParameter",
    async (data) => {

        try {
            const response = await apiDeleteuploadFile(data)
            return response.data
        } catch (err) {
            OpenNotification('danger', err?.response?.data?.message);
        }
    }
)

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    sort: {
        Item: '',
        key: '',
    },
}

const dataSlice = createSlice({
    name: 'ccagenttl/data',
    initialState: {
        loading: false,
        tableData: initialTableData,
        selectedTab: 'All',
        ticketingApprovalStatus: [],
        fleetManagerData: {},
        NewfleetManagerDetails: {},
        fleetDriverData: {},
        dealerDataSugessions: [],
        technicianData: [],
        technicianSugessions: [],
        userPlantCode: [],
        shiftRoasterData: [],
        sugessionSearchData: [],
        DTCAgentSuggestion: [],
        allRSAVehicleData: [],
        selectedDealerDetails: [],
        selectedTicketingId: localStorage.getItem('selectedTicketingId') || '',
        fileUploadData: []
    },
    reducers: {
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
        setLoading: (state, action) => {
            state.tableData = action.payload
        },
        setSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setTechnicianData: (state, action) => {
            state.technicianData = action.payload
        },
        setSelectedTicketingId: (state, action) => {
            state.selectedTicketingId = action.payload
            localStorage.setItem('selectedTicketingId', action.payload)
        },
        setFileUploadData: (state, action) => {
            state.fileUploadData = action.payload
        },




    },
    extraReducers: {
        [getTicketingApprovalData.fulfilled]: (state, action) => {
            state.ticketingApprovalStatus = action.payload
            state.loading = false
        },
        [getTicketingApprovalData.pending]: (state, action) => {
            state.loading = true
        },

        [getSearchbyAgent.fulfilled]: (state, action) => {
            state.DTCAgentSuggestion = action.payload
        },
        [getSelectedVehicleData.fulfilled]: (state, action) => {
            state.selectedDealerDetails = action.payload
            state.loading = false
        },
        [getSelectedVehicleData.pending]: (state, action) => {
            state.loading = true
        },
        [getApprovalTicketingData.fulfilled]: (state, action) => {
            state.ticketingApprovalStatus = action.payload
            state.loading = false
        },
        [getApprovalTicketingData.pending]: (state, action) => {
            state.loading = true
        },
        [getFleetManagerData.fulfilled]: (state, action) => {
            state.fleetManagerData = action.payload
            state.loading = false
        },
        [getFleetManagerData.pending]: (state, action) => {
            state.loading = true
        },
        [getNewFleetManagerDetails.fulfilled]: (state, action) => {
            state.NewfleetManagerDetails = action.payload
            state.loading = false
        },
        [getNewFleetManagerDetails.pending]: (state, action) => {
            state.loading = true
        },
        [getFleetDriverData.fulfilled]: (state, action) => {
            state.fleetDriverData = action.payload
            state.loading = false
        },
        [getFleetDriverData.pending]: (state, action) => {
            state.loading = true
        },
        [getDealerDataSugessions.fulfilled]: (state, action) => {
            state.dealerDataSugessions = action.payload
            state.loading = false
        },
        [getDealerDataSugessions.pending]: (state, action) => {
            state.loading = true
        },
        [getTechnicianData.fulfilled]: (state, action) => {
            state.technicianData = action.payload
            state.loading = false
        },
        [getTechnicianData.pending]: (state, action) => {
            state.loading = true
        },
        [getAllRSAVehicleData.fulfilled]: (state, action) => {
            state.allRSAVehicleData = action.payload
            state.loading = false
        },
        [getAllRSAVehicleData.pending]: (state, action) => {
            state.loading = true
        },
        [getSearchForSuggestion.fulfilled]: (state, action) => {
            state.sugessionSearchData = action.payload
            state.loading = false
        },
        [getUserPlantCode.fulfilled]: (state, action) => {
            state.userPlantCode = action.payload
            state.loading = false
        },
        [getUserPlantCode.pending]: (state, action) => {
            state.loading = true
        },
        [getTechinciansugession.fulfilled]: (state, action) => {
            state.technicianSugessions = action.payload
            // state.loading = false
        },
        [getTechinciansugession.pending]: (state, action) => {
            // state.loading = true
        },
        [getShiftRoasterData.fulfilled]: (state, action) => {
            state.shiftRoasterData = action.payload
            // state.loading = false
        },
        [getShiftRoasterData.pending]: (state, action) => {
            // state.loading = true
        },
    }
})

export const { setTableData, setLoading, setSelectedTicketingId, setSelectedTab, setTechnicianData, setFileUploadData } = dataSlice.actions
export default dataSlice.reducer